import React from 'react';
import Disrupt from '@ux/disrupt';

const UX_MESSAGE_OVERLAY_CLASSNAME = 'ux-message-overlay';

/**
 * <MessageOverlay/> component, props are inherited from <Disrupt/>
 *
 * @param {Object} props - Component props
 * @returns {Component} <MessageOverlay/>
 */
function MessageOverlay(props) {
  const {
    children,
    show,
    ...rest
  } = props;

  if (typeof show !== 'undefined' && !show) return null;

  return <Disrupt { ...rest }>
    <div className={ `${UX_MESSAGE_OVERLAY_CLASSNAME}-content` }>{ children }</div>
  </Disrupt>;
}

MessageOverlay.propTypes = { ...Disrupt.propTypes };

export default MessageOverlay;

